import { render } from "./text-bars2.vue?vue&type=template&id=2b83bec8&scoped=true"
const script = {}

import "./text-bars2.vue?vue&type=style&index=0&id=2b83bec8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b83bec8"],['__file',"src/views/other/cssfx/components/text-bars2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b83bec8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b83bec8', __exports__)) {
    console.log('reload')
    api.reload('2b83bec8', __exports__)
  }
  
  module.hot.accept("./text-bars2.vue?vue&type=template&id=2b83bec8&scoped=true", () => {
    console.log('re-render')
    api.rerender('2b83bec8', render)
  })

}


export default __exports__